import * as boxBuffer from '@/three/buffer-geometries/boxBuffer.js'
import { Brush } from 'three-bvh-csg';
export default class Betonband {
  constructor(THREE, breedte, hoogte, isExtraBetonband) {
    this.THREE = THREE, 
    this.lengte = 60,
    this.breedte = breedte,
    this.hoogte = hoogte ? hoogte : 200,
    this.kleurBetonBand = { color: 0x242323 },
    this.betonBand = null,
    this.isExtraBetonband = isExtraBetonband
    this.buildBetonBand(this.THREE, this.breedte, this.hoogte, this.lengte, this.kleurBetonBand);
  }

  buildBetonBand(THREE, breedte, hoogte, lengte, kleurBetonBand) {

    const kleurBetonBandBinnen = this.isExtraBetonband ? 0xEA5650 : 0xc0bc07;

    const geometrie = new THREE.BufferGeometry()
    geometrie.setAttribute('position', new THREE.BufferAttribute(new Float32Array(boxBuffer.positionBuffer(breedte, hoogte, lengte)), 3))
    geometrie.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(boxBuffer.uvBuffer()), 2))
    geometrie.setAttribute('normal', new THREE.BufferAttribute(new Float32Array(boxBuffer.normalBuffer()), 3))
    geometrie.setIndex(boxBuffer.indexBuffer());
    geometrie.groups = boxBuffer.groupBuffer()

    const material = new THREE.MeshStandardMaterial(kleurBetonBand);
    const betBand = new Brush(geometrie, material);
    betBand.visible = false; // Hide betonbanden
    betBand.castShadow = true; 
    betBand.receiveShadow = true;
    this.betonBand = betBand;
    this.betonBand.position.set(breedte / 2, -hoogte / 2, 0)
    // console.log(breedte / 2, -hoogte / 2, 0)
    
    // this.betonBandBinnen = betBand.clone()
    // this.betonBandBinnen.scale.multiplyScalar(0.999)
    // this.betonBandBinnen.visible = true
    // this.betonBandBinnen.geometry = this.betonBandBinnen.geometry.clone()
    // flipGeometryFaces(this.betonBandBinnen.geometry)
    // this.betonBandBinnen.position.set(0,0,0)
    // this.betonBandBinnen.material = new THREE.MeshBasicMaterial({color: 0xc0bc07, /*side: THREE.BackSide*/});
    // this.betonBand.add(this.betonBandBinnen)
    // console.log("betonBandBinnen", this.betonBandBinnen);
    this.betonBandBinnen = new THREE.Mesh(
      new THREE.PlaneGeometry(1, 1),
      new THREE.MeshBasicMaterial({ color: kleurBetonBandBinnen })
    )
    this.betonBandBinnen.rotation.x = -Math.PI/2
    this.betonBandBinnen.scale.set(breedte, lengte, 1)
    this.betonBandBinnen.position.y = -hoogte/2 + 10
    if (this.isExtraBetonband) {
      this.betonBandBinnen.position.y = hoogte/2 + 10 + 10
    }
    this.betonBand.add(this.betonBandBinnen)
  }
  
  update(breedte) {
    this.breedte = breedte;
    // this.random = Math.random();
    // console.error("update betonband", breedte, this.random)
    // const geometrie = new this.THREE.BufferGeometry()
    // geometrie.setAttribute('position', new this.THREE.BufferAttribute(new Float32Array(boxBuffer.positionBuffer(this.breedte, this.hoogte, this.lengte)), 3))
    // geometrie.setAttribute('uv', new this.THREE.BufferAttribute(new Float32Array(boxBuffer.uvBuffer()), 2))
    // geometrie.setAttribute('normal', new this.THREE.BufferAttribute(new Float32Array(boxBuffer.normalBuffer()), 3))
    // geometrie.setIndex(boxBuffer.indexBuffer());
    // geometrie.groups = boxBuffer.groupBuffer()
    // this.betonBand.geometry = geometrie;
    // this.betonBand.position.set(this.breedte / 2, -this.hoogte / 2, 0)
    // // this.betonBandBinnen.geometry = geometrie.clone();
    // // flipGeometryFaces(this.betonBandBinnen.geometry);
    // this.betonBandBinnen.scale.set(this.breedte, this.lengte, 1)
    // this.betonBandBinnen.position.y = -this.hoogte/2 + 10
    const visible = this.betonBand.visible;
    this.betonBand.removeFromParent();
    this.buildBetonBand(this.THREE, this.breedte, this.hoogte, this.lengte, this.kleurBetonBand);
    this.betonBand.visible = visible;
  }

  // Functie om een betonband zichtbaar te maken
  betonBandShow() {
    this.betonBand.visible = true
  }

  // Functie om een betonband niet zichtbaar te maken
  betonBandHide() {
    this.betonBand.visible = false
  }


}

function flipGeometryFaces(geometry) {
  // Flip normals
  const normals = geometry.attributes.normal;
  if (normals) {
    for (let i = 0; i < normals.count; i++) {
      normals.setX(i, -normals.getX(i));
      normals.setY(i, -normals.getY(i));
      normals.setZ(i, -normals.getZ(i));
    }
    normals.needsUpdate = true;
  }

  // Flip triangle winding order
  if (geometry.index) {
    const index = geometry.index.array;
    for (let i = 0; i < index.length; i += 3) {
      // Swap second and third vertex to reverse the triangle
      const tmp = index[i + 1];
      index[i + 1] = index[i + 2];
      index[i + 2] = tmp;
    }
    geometry.index.needsUpdate = true;
  } else {
    // Non-indexed geometry → swap positions directly
    const positions = geometry.attributes.position;
    const vertex = [];

    for (let i = 0; i < positions.count; i += 3) {
      // Swap v1 ↔︎ v2
      for (let axis = 0; axis < 3; axis++) {
        const a = positions.getX(i + 1 + axis);
        const b = positions.getX(i + 2 + axis);
        positions.setX(i + 1 + axis, b);
        positions.setX(i + 2 + axis, a);
      }
    }

    positions.needsUpdate = true;
  }

  // Ensure vertex normals regenerate properly if needed
  geometry.computeVertexNormals();
}